export default "skymp5-front/5ece995b0f1ef6e87739212f14cd67be.png";